import React, { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import liracrypt from "../../components/Liracrypt/liracrypt";
import { Spin, Form, Select, Card } from "antd";
import SessionError from "../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import LineDashTabComp from "./LineDashTabComp";

const DashLayout = () => {
  const [selectedLid, setSelectedLid] = useState(null);
  const [loadLineAccess, setLoadLineAccess] = useState(null);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [loginError, setLoginError] = useState(false);

  const fetchLineAccess = () => {
    liracrypt
      .get("/linedashboard/access", {})
      .then(({ data }) => {
        setLoadLineAccess(data.data);
      })
      .catch(function (error) {
        
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (loadLineAccess === null) {
      fetchLineAccess();
    }
  }, [loadLineAccess]);

  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        {selectedLid ? (
          <LineDashTabComp selectedLid={selectedLid} />
        ) : (
          <div
            className="dash"
            style={{
              // backgroundColor: "#222",
              height: "100vh",
              backgroundColor: "#262626",
              overflow: "hidden",
            }}
          >
            <Card
              title={
                <span style={{ fontWeight: 600 }}>Please select a line</span>
              }
              bordered={false}
              style={{
                width: "600px",
                margin: "10% auto",
                backgroundColor: "#424358",
                border: 0,
                boxShadow: "5px 5px 10px #1f1f1f, -5px -5px 10px #2d2d2d",
                borderRadius: "10px",
                fontWeight: "600",
                padding: "10px",
              }}
            >
              {loadLineAccess ? (
                <Form.Item
                  className="selectLine"
                  rules={[{ required: true, message: "Select a line" }]}
                >
                  <Select
                    showSearch
                    style={{ width: 200 }}
                    placeholder="Select a line"
                    optionFilterProp="children"
                    onChange={(value) => {
                      
                      setSelectedLid(value);
                    }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {loadLineAccess.map((obj) => (
                      <Select.Option value={obj._id}>{obj.lame}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              ) : (
                <div className="Loading">
                  <Spin indicator={antIcon} />
                </div>
              )}
            </Card>
          </div>
        )}
      </React.Fragment>
    </>
  );
};
export default DashLayout;
